export default __webpack_public_path__ + "static/media/check-circle-green.9e34e600.svg";